<div class="student-groups-list-content">
  <app-student-groups-list-card
    [studentGroups]="studentGroups"
    [tableFilters]="tableFilters"
    (tableFiltersUpdated)="updateTableFilters($event)"
    (studentGroupRemoved)="deleteStudentGroup($event)">
  </app-student-groups-list-card>
</div>
